<!-- Barra para adicionar conteudo fixa no post -->
<template>
  <div class="container-buttons d-flex align-items-end justify-content-center mt-3 mt-md-5">
    <div class="container-buttons-tool wrapper d-flex justify-content-center flex-wrap">
      <div
        class="p-3 item-container"
        v-for="(button, index) in frameButtons"
        :key="button.icon"
      >
        <div
          v-b-tooltip.hover
          :title="button.tooltip"
          class="bottom-button"
          @click="clickButton(index)"
        >
          <i v-if="button.icon" :class="[button.icon]"></i>
          <img
            v-else
            class="img-svg img-svg-color"
            src="../../assets/img/icons/before-after.svg"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      active: false,
      extraButtonStatus: true,
      defaultClass: '',
    };
  },
  methods: {
    clickButton(index) {
      this.$emit("addContent", index);
      //button.clickEvent(index)
      this.active = true;
    },
  },
  props: {
    frameButtons: Array,
    slotNum: Number
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/molecules/AddPostBarFixed.vue